import React from 'react';
import { Button, Col, Row } from 'antd';
import '../About.css';
import {LoadingOutlined} from "@ant-design/icons";
import {useSelector} from "react-redux";
const AboutBtn = (props) => {
    const loading = useSelector((state) => state.getCompanyDetailsReducer.loadingAbout);
    return (
        <div className="abt-buttons-row">
            <div className={'btn-column'}>
                <Button type="default" htmlType="submit" className="save-btn" disabled={loading} onClick={()=>{
                    props.onSave();
                }}>{loading?<LoadingOutlined/>:"Save"}</Button>
            </div>
        </div>
    );
}
export default AboutBtn;









